const Data = [
   {
    id: 1,
    imgSrc:
      "https://cdn.pixabay.com/photo/2020/08/29/16/08/pikachu-5527377_1280.jpg",
    name: "Pikachu",
    link: "https://pixabay.com/illustrations/pikachu-pokemon-character-cartoon-5527377/",
    size: "large",
  },
  {
    id: 2,
    imgSrc:
      "https://cdn.pixabay.com/photo/2020/10/12/21/10/cosplay-5650210_1280.jpg",
    name: "Spidy",
    link: "https://pixabay.com/photos/cosplay-spiderman-marvel-costume-5650210/",
    size: "medium",
  },
  {
    id: 3,
    imgSrc:
      "https://cdn.pixabay.com/photo/2020/04/17/15/01/harry-potter-5055509_1280.jpg",
    name: "Harry Potter",
    link: "https://pixabay.com/photos/harry-potter-funco-fantasy-books-5055509/",
    size: "small",
  }, 
  {
    id: 4,
    imgSrc:
      "https://cdn.pixabay.com/photo/2016/11/14/09/14/cat-1822979_960_720.jpg",
    name: "Mshyun",
    link: "https://pixabay.com/photos/cat-christmas-tree-ornaments-1822979/",
    size: "medium",
  },
    {
    id: 5,
    imgSrc:
      "https://cdn.pixabay.com/photo/2020/02/11/09/26/love-4838874_1280.jpg",
    name: "Heart",
    link: "https://pixabay.com/illustrations/love-valentine-valentine-day-4838874/",
    size: "medium",
  },
  {
    id: 6,
    imgSrc:
      "https://cdn.pixabay.com/photo/2021/10/13/07/43/couple-6705694_960_720.jpg",
    name: "Jupilu",
    link: "https://pixabay.com/photos/couple-sundown-field-sunset-6705694/",
    size: "small",
  },
  {
    id: 7,
    imgSrc:
      "https://cdn.pixabay.com/photo/2023/01/09/10/52/whale-7707126_1280.jpg",
    name: "Dolphin",
    link: "https://pixabay.com/illustrations/whale-space-dream-fantasy-clouds-7707126/",
    size: "large",
  },
  {
    id: 8,
    imgSrc:
      "https://cdn.pixabay.com/photo/2015/01/28/23/35/hills-615429_1280.jpg",
    name: "Fog",
    link: "https://pixabay.com/photos/hills-trees-fog-morning-fog-foggy-615429/",
    size: "small",
  },
  {
    id: 9,
    imgSrc:
      "https://cdn.pixabay.com/photo/2021/11/26/20/44/lantern-6826687_960_720.jpg",
    name: "Lasrs Nissen",
    link: "https://pixabay.com/photos/lantern-sea-sky-beach-water-6826687/",
    size: "medium",
  },
    {
    id: 10,
    imgSrc:
      "https://cdn.pixabay.com/photo/2022/11/19/18/06/mobile-wallpaper-7602768_1280.jpg",
    name: "Lego Emoji",
    link: "https://pixabay.com/photos/mobile-wallpaper-lego-faces-emoji-7602768/",
    size: "large",
  },
  {
    id: 11,
    imgSrc:
      "https://cdn.pixabay.com/photo/2012/06/19/10/32/owl-50267_960_720.jpg",
    name: "Chraecker",
    link: "https://pixabay.com/photos/owl-bird-animal-bird-of-prey-50267/",
    size: "small",
  },
  {
    id: 12,
    imgSrc:
      "https://cdn.pixabay.com/photo/2017/06/07/10/47/elephant-2380009_960_720.jpg",
    name: "Comfreak",
    link: "https://pixabay.com/photos/elephant-watering-hole-baby-elephant-2380009/",
    size: "medium",
  },
  {
    id: 13,
    imgSrc:
      "https://cdn.pixabay.com/photo/2016/11/08/05/26/woman-1807533_960_720.jpg",
    name: "Sasinet",
    link: "https://pixabay.com/photos/woman-kid-rain-leaf-umbrella-1807533/",
    size: "large",
  },
  {
    id: 14,
    imgSrc:
      "https://cdn.pixabay.com/photo/2019/08/19/07/45/dog-4415649_960_720.jpg",
    name: "Hauad",
    link: "https://pixabay.com/photos/dog-corgi-pets-cute-rain-4415649/",
    size: "medium",
  },
  {
    id: 15,
    imgSrc:
      "https://cdn.pixabay.com/photo/2017/01/28/02/24/japan-2014619_960_720.jpg",
    name: "Chau min",
    link: "https://pixabay.com/photos/japan-osaka-night-asia-landmark-2014619/",
    size: "large",
  },
  {
    id: 16,
    imgSrc:
      "https://cdn.pixabay.com/photo/2015/10/22/17/45/leaf-1001679_960_720.jpg",
    name: "Steven",
    link: "https://pixabay.com/photos/leaf-green-foliage-green-leaves-1001679/",
    size: "medium",
  },
  {
    id: 17,
    imgSrc:
      "https://cdn.pixabay.com/photo/2018/05/16/22/27/rose-3407234_960_720.jpg",
    name: "Rosee",
    link: "https://pixabay.com/photos/rose-red-drops-rain-macro-nature-3407234/",
    size: "medium",
  },
  {
    id: 18,
    imgSrc:
      "https://cdn.pixabay.com/photo/2018/01/29/19/00/park-3116883_960_720.jpg",
    name: "Arcoin",
    link: "https://pixabay.com/photos/park-bench-night-evening-fog-mist-3116883/",
    size: "large",
  },
  {
    id: 19,
    imgSrc:
      "https://cdn.pixabay.com/photo/2016/11/22/23/44/porsche-1851246_960_720.jpg",
    name: "Pexel",
    link: "https://pixabay.com/photos/porsche-car-brake-lights-1851246/",
    size: "small",
  },
  {
    id: 20,
    imgSrc:
      "https://cdn.pixabay.com/photo/2016/06/05/20/41/girl-1438138_960_720.jpg",
    name: "Xusenru",
    link: "https://pixabay.com/photos/girl-umbrella-rain-park-autumn-1438138/",
    size: "large",
  },
  {
    id: 21,
    imgSrc:
      "https://cdn.pixabay.com/photo/2020/08/21/08/59/boy-5505633_1280.jpg",
    name: "JellyFish",
    link: "https://pixabay.com/photos/boy-sofa-jellyfish-sea-creature-5505633/",
    size: "large",
  },
  {
    id: 22,
    imgSrc:
      "https://cdn.pixabay.com/photo/2016/11/29/11/12/rain-1869119_960_720.jpg",
    name: "Pexel",
    link: "https://pixabay.com/photos/rain-woman-brunette-portrait-1869119/",
    size: "medium",
  },
  {
    id: 23,
    imgSrc:
      "https://cdn.pixabay.com/photo/2016/11/19/11/11/hands-1838659_960_720.jpg",
    name: "Pexel",
    link: "https://pixabay.com/photos/hands-plant-soil-grow-growing-1838659/",
    size: "medium",
  },
  {
    id: 24,
    imgSrc:
      "https://cdn.pixabay.com/photo/2019/01/25/11/18/girl-3954232_960_720.jpg",
    name: "Pexel",
    link: "https://pixabay.com/photos/girl-rain-femininity-beauty-paris-3954232/",
    size: "large",
  },
  {
    id: 25,
    imgSrc:
      "https://cdn.pixabay.com/photo/2013/02/20/10/32/snail-83672_960_720.jpg",
    name: "Larisa",
    link: "https://pixabay.com/illustrations/snail-drops-rain-raindrops-mollusk-83672/",
    size: "samll",
  },
  {
    id: 26,
    imgSrc:
      "https://cdn.pixabay.com/photo/2020/08/30/09/28/buildings-5528981_960_720.jpg",
    name: "China Town",
    link: "https://pixabay.com/photos/buildings-houses-street-city-rain-5528981/",
    size: "small",
  },
  {
    id: 27,
    imgSrc:
      "https://cdn.pixabay.com/photo/2017/03/12/02/20/triangle-2136288_960_720.jpg",
    name: "Pyramid",
    link: "https://pixabay.com/illustrations/triangle-sky-abstract-wallpaper-2136288/",
    size: "large",
  },
  {
    id: 28,
    imgSrc:
      "https://cdn.pixabay.com/photo/2018/10/12/09/07/india-3741733_1280.jpg",
    name: "Dragon Fly",
    link: "https://pixabay.com/photos/india-dragonfly-insect-macro-3741733/",
    size: "small",
  },
  {
    id: 29,
    imgSrc:
      "https://cdn.pixabay.com/photo/2020/05/19/13/05/heart-5190672_960_720.jpg",
    name: "Heart",
    link: "https://pixabay.com/photos/heart-window-rain-drops-love-5190672/",
    size: "small",
  },
  {
    id: 30,
    imgSrc:
      "https://cdn.pixabay.com/photo/2014/11/30/14/11/cat-551554_960_720.jpg",
    name: "cat",
    link: "https://pixabay.com/photos/cat-kitten-pet-kitty-young-cat-551554/",
    size: "large",
  },
];

export default Data;
